import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { UrlObject } from 'url';
import Icon, { ICON_NAME } from '@features/ui/components/Icon';
import { textH1 } from '@features/ui/styles/textStyles';

const PageTitle = ({
  title,
  backUrlParams,
  backFunction,
  className,
}: {
  title: string;
  backUrlParams?: UrlObject;
  backFunction?: (e) => void;
  className?: string;
}) => (
  <Container className={className}>
    <Left>
      {backUrlParams && (
        <Link href={backUrlParams}>
          <a>
            <StyledIcon
              color="var(--color-orange)"
              size="24px"
              name={ICON_NAME.keyboardReturn}
            />
          </a>
        </Link>
      )}
      {backFunction && (
        <StyledIcon
          color="var(--color-orange)"
          size="24px"
          name={ICON_NAME.keyboardReturn}
          onClick={backFunction}
        />
      )}
      <Title>{title}</Title>
    </Left>
  </Container>
);
export default PageTitle;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Left = styled.div`
  display: flex;
  align-items: baseline;
`;

const Title = styled.h1`
  ${textH1};
`;
const StyledIcon = styled(Icon)`
  margin-right: 12px;
`;
